export const ru = {
  common: {
    appName: 'Novix',
    loading: 'Загрузка…',
    retry: 'Повторить',
    cancel: 'Отмена',
    close: 'Закрыть',
    confirm: 'Подтвердить',
    back: 'Назад',
    continue: 'Продолжить',
    save: 'Сохранить',
    copy: 'Скопировать',
    copied: 'Скопировано',
    copyFailed: 'Не удалось скопировать. Выделите текст вручную.',
    download: 'Скачать',
    done: 'Готово',
    language: 'Язык',
    next: 'Далее',
    // «Всё» на кнопке внутри поля суммы — переносит весь доступный остаток.
    max: 'Всё',
    backHome: 'На главную',
    seeAll: 'Смотреть все',
    quickAmounts: 'Быстрый выбор суммы',
    noFee: 'Без комиссии',
    fee: 'Комиссия: {{amount}}',
    total: 'Итого',
    edit: 'Изменить',
    delete: 'Удалить',
    comingSoon: 'Раздел появится в следующих фазах.'
  },
  nav: {
    primary: 'Основная навигация',
    home: 'Главная',
    history: 'История',
    wallet: 'Кошелёк',
    cards: 'Карты',
    payouts: 'Выводы',
    profile: 'Профиль'
  },
  wallet: {
    yourBalance: 'Ваш баланс',
    hideBalance: 'Скрыть баланс',
    showBalance: 'Показать баланс',
    balanceHidden: 'Баланс скрыт',
    transactions: 'Операции',
    addCard: 'Добавить',
    totalBalance: 'Общий баланс',
    balanceNotAvailable: 'Баланс пока недоступен',
    balanceFailed: 'Не удалось загрузить баланс',
    actions: {
      deposit: 'Пополнить',
      withdraw: 'Вывести',
      transfer: 'Перевести'
    },
    yourCards: 'Ваши карты',
    cardsEmptyTitle: 'Карт пока нет',
    cardsEmptyBody: 'Выпуск карт появится в следующей фазе.',
    recentActivity: 'Последние операции',
    seeAll: 'Все операции',
    activityScopeNote:
      'В списке пополнения, выводы и переводы. Операции по картам появятся в следующих фазах.'
  },
  activity: {
    title: 'Операции',
    empty: 'Операций пока нет.',
    unavailable: 'Не удалось загрузить историю операций.',
    partial: 'Часть истории загрузить не удалось — список может быть неполным.',
    toUser: 'Пользователю #{{id}}',
    fromUser: 'От пользователя #{{id}}',
    cardUnknown: 'Карта',
    kind: {
      deposit: { in: 'Пополнение', out: 'Пополнение' },
      withdrawal: { in: 'Вывод в криптовалюте', out: 'Вывод в криптовалюте' },
      payout: { in: 'Вывод на карту', out: 'Вывод на карту' },
      transfer: { in: 'Входящий перевод', out: 'Исходящий перевод' }
    },
    status: {
      pending: 'В обработке',
      completed: 'Выполнено',
      failed: 'Отклонено',
      // Намеренно другое слово и другой цвет, чем у «Отклонено»: операция не
      // прошла, но деньги вернулись на баланс. Это разные факты.
      reversed: 'Возвращено',
      unresolved: 'Уточняется'
    },
    secondary: {
      deposit: 'Зачислено {{amount}}',
      withdrawal: 'Списано {{amount}}',
      payout: 'Списано {{amount}}',
      transfer: 'Списано {{amount}}'
    }
  },
  withdraw: {
    methodTitle: 'Вывести',
    methodSubtitle: 'Выберите, куда отправить средства.',
    methodCrypto: 'Криптовалюта',
    methodCryptoHint: 'USDT на внешний адрес в сети TRON или BNB Smart Chain',
    methodCard: 'Банковская карта',
    methodCardHint: 'Рубли на карту, от 5 000 ₽',
    methodTransfer: 'Перевод внутри Novix',
    methodTransferHint: 'USDT другому пользователю по его ID',

    amountLabel: 'Сумма в {{currency}}',
    amountNotANumber: 'Введите сумму числом',
    max: 'Максимум',
    confirm: 'Подтвердить вывод',
    stepUpNote: 'Для подтверждения понадобится код из приложения-аутентификатора.',
    quoteUnavailableTitle: 'Расчёт недоступен',
    historyPollNote: 'Статус обновляется автоматически.',

    // Экран проверки перед подтверждением. Вывод средств необратим: именно
    // здесь ловятся лишний ноль и адрес, вставленный не оттуда.
    review: {
      summaryLabel: 'Проверьте операцию',
      edit: 'Изменить данные',
      note: 'Проверьте сумму и получателя. Отменить операцию после подтверждения нельзя.'
    },
    receipt: {
      summaryLabel: 'Детали операции',
      dateTime: 'Дата и время',
      txHash: 'Хеш транзакции',
      operationId: 'ID операции'
    },

    destination: {
      crypto: 'на адрес',
      card: 'на карту'
    },

    submitted: {
      // 200 — это не «отправлено». Средства списаны и стоят в очереди; слово
      // «отправлено» появляется только когда бэкенд подтвердил завершение.
      pending: {
        title: 'Заявка принята',
        body: 'Средства списаны и поставлены в очередь на отправку {{destination}}. Ничего ещё не отправлено — статус обновится автоматически.'
      },
      completed: {
        title: 'Отправлено',
        body: 'Средства отправлены {{destination}}.'
      },
      reversed: {
        title: 'Операция отменена, средства возвращены',
        body: 'Отправить {{destination}} не удалось. Списанная сумма полностью возвращена на баланс.'
      },
      unresolved: {
        title: 'Результат уточняется',
        body: 'Мы пока не знаем, дошли ли средства {{destination}}. Операцию проверяет специалист; автоматический возврат в этом случае не выполняется.'
      },
      failed: {
        title: 'Операция отклонена',
        body: 'Отправить {{destination}} не удалось.'
      },
      reason: 'Причина: {{reason}}',
      startAnother: 'Создать ещё одну операцию'
    },

    crypto: {
      title: 'Вывод криптовалюты',
      subtitle: 'Укажите сеть, адрес получателя и сумму.',
      chooseNetwork: 'Сеть вывода',
      addressLabel: 'Адрес получателя',
      addressHint: 'Адрес в сети {{network}}.',
      addressPlaceholder: {
        trc20: 'T…',
        bsc: '0x…'
      },
      addressInvalid: 'Это не похоже на адрес в сети {{network}}. Проверьте адрес.',
      addressOtherNetwork:
        'Этот адрес похож на адрес другой сети, а не {{network}}. Отправка приведёт к безвозвратной потере средств.',
      warningTitle: 'Отправка только в сети {{network}}',
      warningBody:
        'Средства уйдут в сеть {{network}}. Если адрес получателя принадлежит другой сети, {{currency}} будут потеряны безвозвратно — отменить перевод невозможно.',
      recipientGets: 'Получатель получит',
      networkFee: 'Комиссия сети',
      networkFeeHint: 'Списывается сверх суммы',
      commission: 'Комиссия Novix',
      totalDebit: 'Спишется с баланса',
      minimum: 'Минимальная сумма',
      maxWithdrawable: 'Доступно к выводу',
      maxWithdrawableHint: 'Баланс за вычетом комиссий',
      remainingDailyLimit: 'Остаток дневного лимита',
      summaryLabel: 'Расчёт вывода',
      networkRow: 'Сеть',
      recipientRow: 'Получатель',
      belowMinimum: 'Минимальная сумма вывода — {{amount}}',
      aboveMax: 'Доступно к выводу не больше {{amount}}',
      historyTitle: 'Выводы в криптовалюте'
    },

    card: {
      title: 'Вывод на карту',
      subtitle: 'Укажите сумму в рублях и карту получателя.',
      amountLabel: 'Сумма в рублях',
      minimumHint: 'Минимальная сумма вывода — {{amount}}.',
      belowMinimum: 'Минимальная сумма вывода — {{amount}}',
      belowMinimumUnknown: 'Сумма меньше минимальной для вывода на карту.',
      recipientGets: 'На карту поступит',
      rate: 'Курс',
      rateValue: '1 USDT = {{rate}} ₽',
      commission: 'Комиссия Novix',
      usdtDebit: 'Спишется с баланса',
      usdtDebitHint: 'Комиссия включена',
      minimum: 'Минимальная сумма',
      summaryLabel: 'Расчёт вывода на карту',
      cardRow: 'Карта получателя',
      amountRow: 'Сумма',
      numberLabel: 'Номер карты получателя',
      numberHint: '16 цифр на лицевой стороне карты.',
      numberInvalid: 'Проверьте номер карты — он введён с ошибкой.',
      numberChecked: 'Номер карты прошёл проверку',
      numberRejected: 'Банк не принял этот номер карты. Проверьте его и попробуйте ещё раз.',
      privacyNote: 'Номер карты передаётся только платёжному партнёру и нигде не сохраняется.',
      historyTitle: 'Выводы на карту'
    }
  },
  transfer: {
    title: 'Перевод внутри Novix',
    subtitle: 'Отправьте USDT другому пользователю Novix по его ID.',
    recipientLabel: 'ID получателя',
    recipientHint: 'Числовой идентификатор пользователя Novix.',
    recipientInvalid: 'ID получателя — это число.',
    noteLabel: 'Комментарий (необязательно)',
    noteHint: 'Увидит получатель. До 140 символов.',
    recipientGets: 'Получатель получит',
    fee: 'Комиссия Novix',
    feeHint: 'Списывается сверх суммы',
    totalDebit: 'Спишется с баланса',
    availableBalance: 'Доступно на балансе',
    summaryLabel: 'Расчёт перевода',
    recipientRow: 'Получатель',
    reviewNote: 'Получатель увидит перевод в приложении Novix.',
    insufficientFunds: 'На балансе недостаточно средств для этого перевода вместе с комиссией.',
    belowMinimum: 'Минимальная сумма перевода — {{amount}}',
    confirm: 'Отправить перевод',
    // Перевод — единственная денежная операция без внешнего вызова: одна
    // транзакция в леджере, поэтому здесь «выполнено» это правда.
    sentTitle: 'Перевод выполнен',
    sentBody: 'Пользователь #{{id}} получил {{amount}}.',
    sendAnother: 'Сделать ещё один перевод',
    historyTitle: 'Переводы'
  },
  deposit: {
    methodTitle: 'Пополнить',
    methodSubtitle: 'Выберите способ пополнения счёта.',
    methodCrypto: 'Криптовалюта',
    methodCryptoHint: 'USDT в сетях TRON и BNB Smart Chain',
    methodCard: 'Банковская карта',
    methodInternal: 'Перевод от другого пользователя',

    shareId: {
      rowHint: 'Показать ваш ID для перевода',
      transferLink: 'Мой ID для получения перевода',
      heading: 'Ваш ID в Novix',
      lead: 'Отправьте этот ID тому, кто хочет перевести вам средства: по нему он найдёт ваш счёт.',
      scopeNote:
        'ID работает только для переводов между пользователями Novix. Для пополнения из другого кошелька или банка он не подходит.',
      failedTitle: 'Не удалось загрузить ваш ID'
    },

    cryptoTitle: 'Пополнение в криптовалюте',
    cryptoSubtitle: 'Выберите сеть и отправьте средства на адрес ниже.',
    chooseNetwork: 'Выберите сеть',
    networks: {
      trc20: 'TRON (TRC20)',
      bsc: 'BNB Smart Chain (BEP-20)',
      unknown: 'Неизвестная сеть'
    },
    networkHints: {
      trc20: 'Сеть Tron',
      bsc: 'Сеть BNB Smart Chain'
    },

    addressFor: 'Ваш адрес {{currency}} в сети {{network}}',
    addressLabel: 'Адрес для пополнения',
    addressLength: 'Длина адреса — {{length}}. Он показан целиком, без сокращений.',
    copyAddress: 'Скопировать адрес',
    qrLabel: 'QR-код адреса {{currency}} в сети {{network}}',

    warning: {
      title: 'Отправляйте только в сети {{network}}',
      body: 'Перевод, отправленный в другой сети, будет потерян безвозвратно: вернуть его невозможно. Проверьте, что кошелёк-отправитель отправляет {{currency}} именно в сети {{network}}.'
    },

    minimumLabel: 'Минимальная сумма пополнения',
    minimumHint: 'Перевод на сумму меньше {{amount}} не будет зачислен.',
    feeFrom: 'от {{amount}}',
    // Пилюля на экране выбора способа: показывается, когда API сообщил нулевую
    // комиссию, и никогда — вместо комиссии, которую не удалось прочитать.
    // См. DepositMethodPage.
    //
    // Отдельный ключ, а не common.noFee (его использует строка комиссии на
    // экране адреса), потому что у пилюли жёсткий бюджет ширины: на 390px она
    // стоит вплотную к слову «Криптовалюта», которое не переносится по слогам,
    // и «Без комиссии» ломает его посреди слова. Ровно это уже чинили один
    // раз — см. комментарий у FeePill.
    feeNone: 'Бесплатно',
    feeLabel: 'Комиссия провайдера',
    feeHint:
      'Провайдер удерживает {{fee}} с каждого пополнения в сети {{network}} независимо от суммы. При маленьком пополнении почти всё уйдёт в комиссию.',
    feeFreeHint:
      'Пополнение в сети {{network}} зачисляется полностью — провайдер не удерживает комиссию.',
    // Своя цифра строки истории, из вебхука. Нужна потому, что строка может
    // нести комиссию в тот день, когда экран выше говорит, что её нет.
    rowFee: 'Комиссия {{amount}}',

    addressFailedTitle: 'Не удалось получить адрес',

    historyTitle: 'Пополнения',
    historyEmpty: 'Пополнений пока нет.',
    historyUnavailable: 'Не удалось загрузить историю пополнений.',
    historyPollNote: 'Список обновляется автоматически. Зачисление занимает несколько минут.',
    rowTitle: 'Пополнение',
    credited: 'Зачислено {{amount}}',
    openReceipt: 'Открыть детали пополнения',
    receipt: {
      summaryLabel: 'Детали пополнения',
      detailsLabel: 'Транзакция',
      amount: 'Сумма перевода',
      credited: 'Зачислено на баланс',
      creditedPending: 'Будет известно после зачисления',
      dateTime: 'Дата и время',
      txHash: 'Хеш транзакции',
      operationId: 'ID операции',
      notFoundTitle: 'Пополнение не найдено',
      notFoundBody: 'Эта операция отсутствует в истории пополнений.'
    },
    status: {
      pending: 'В обработке',
      confirmed: 'Зачислено',
      failed: 'Отклонено'
    },
    backHome: 'Вернуться на главную'
  },
  auth: {
    login: 'Вход',
    email: 'Электронная почта',
    emailPlaceholder: 'you@example.com',
    password: 'Пароль',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
    signIn: 'Войти',
    signOut: 'Выйти',
    totpTitle: 'Код подтверждения',
    totpHint: 'Введите шестизначный код из приложения-аутентификатора',

    welcomeTitle: 'Novix — кошелёк USDT',
    loginTitle: 'Войти в аккаунт',
    loginSubtitle: 'Введите почту и пароль, чтобы продолжить',
    forgotPassword: 'Забыли пароль?',
    noAccount: 'Нет аккаунта?',
    createAccount: 'Зарегистрироваться',
    haveAccount: 'Уже есть аккаунт?',
    backToLogin: 'Вернуться ко входу',

    gate: {
      checking: 'Проверяем сессию…',
      failedTitle: 'Не удалось проверить сессию',
      // Намеренно не утверждаем, что пользователь вышел: мы этого не знаем.
      failedBody:
        'Нет связи с сервером, поэтому мы не можем подтвердить вход. Проверьте подключение и повторите — или войдите заново.'
    },

    sessionEnded: {
      revokedTitle: 'Вы вышли из системы в целях безопасности',
      revoked:
        'Сессия прервана: устаревший токен обновления был использован повторно. Если это были не вы, смените пароль сразу после входа.',
      expiredTitle: 'Сессия завершена',
      expired: 'Срок действия сессии истёк. Войдите заново.'
    },

    register: {
      title: 'Создать аккаунт',
      step: 'Шаг {{current}} из {{total}}',
      emailStepTitle: 'Укажите почту',
      emailStepHint: 'На неё придёт ссылка для подтверждения аккаунта.',
      passwordStepTitle: 'Придумайте пароль',
      passwordStepHint: 'Он понадобится для входа в аккаунт {{email}}.',
      confirmPassword: 'Повторите пароль',
      submit: 'Создать аккаунт',
      changeEmail: 'Изменить почту',
      successTitle: 'Проверьте почту',
      // Формулировка намеренно не подтверждает существование аккаунта — бэкенд
      // отвечает одинаково и для новой, и для занятой почты.
      successBody:
        'Если на этот адрес можно зарегистрировать аккаунт, мы отправили письмо со ссылкой подтверждения на {{email}}.',
      successHint: 'Ссылка действует ограниченное время. Проверьте папку «Спам».',
      resend: 'Отправить письмо ещё раз',
      resendIn: 'Отправить повторно можно через {{seconds}} с',
      resent: 'Письмо отправлено ещё раз.',
      devLinkTitle: 'Режим разработки',
      devLinkBody: 'Бэкенд вернул токен подтверждения. В продакшене этого не происходит.',
      devLinkAction: 'Открыть ссылку подтверждения'
    },

    passwordRules: {
      requirementsTitle: 'Пароль должен содержать:',
      minLength: 'не менее {{count}} символов',
      letterAndDigit: 'хотя бы одну букву и одну цифру',
      maxLength: 'не более {{count}} символов',
      required: 'Введите пароль',
      tooShort: 'Пароль должен содержать не менее {{count}} символов',
      tooLong: 'Пароль должен содержать не более {{count}} символов',
      needsLetterAndDigit: 'Пароль должен содержать хотя бы одну букву и одну цифру',
      mismatch: 'Пароли не совпадают',
      requirementMet: 'выполнено',
      requirementUnmet: 'не выполнено'
    },

    emailErrors: {
      required: 'Введите адрес электронной почты',
      invalid: 'Проверьте адрес электронной почты',
      tooLong: 'Адрес электронной почты слишком длинный'
    },

    confirmEmail: {
      title: 'Подтверждение почты',
      verifying: 'Проверяем ссылку…',
      successTitle: 'Почта подтверждена',
      successBody: 'Аккаунт активирован. Теперь можно войти.',
      failedTitle: 'Ссылка недействительна',
      failedBody: 'Ссылка уже использована или срок её действия истёк. Запросите новую.',
      missingTokenTitle: 'Нет токена подтверждения',
      missingTokenBody: 'Откройте ссылку из письма целиком — в адресе не хватает параметра token.',
      goToLogin: 'Перейти ко входу',
      requestNewLink: 'Запросить новую ссылку'
    },

    forgot: {
      title: 'Восстановление пароля',
      subtitle: 'Укажите почту вашего аккаунта — мы отправим ссылку для сброса пароля.',
      submit: 'Отправить ссылку',
      sentTitle: 'Проверьте почту',
      // Тот же принцип, что и при регистрации: ответ не раскрывает,
      // существует ли аккаунт.
      sentBody:
        'Если аккаунт с адресом {{email}} существует, мы отправили на него ссылку для сброса пароля.',
      sentHint: 'Ссылка действует ограниченное время. Проверьте папку «Спам».'
    },

    reset: {
      title: 'Новый пароль',
      subtitle: 'Придумайте новый пароль для аккаунта.',
      submit: 'Сохранить пароль',
      successTitle: 'Пароль изменён',
      successBody: 'Теперь войдите с новым паролем.',
      missingTokenTitle: 'Нет токена сброса',
      missingTokenBody: 'Откройте ссылку из письма целиком — в адресе не хватает параметра token.',
      requestNewLink: 'Запросить новую ссылку'
    },

    twoFactor: {
      challengeTitle: 'Подтверждение входа',
      challengeSubtitle: 'Введите шестизначный код из приложения-аутентификатора.',
      verify: 'Подтвердить',
      expiresIn: 'Код нужно ввести за {{time}}',
      expiredTitle: 'Время истекло',
      expiredBody: 'Подтверждение входа действует ограниченное время. Войдите заново.',
      restart: 'Войти заново',
      noSessionTitle: 'Нет активного входа',
      noSessionBody: 'Начните вход с ввода почты и пароля.',
      useRecovery: 'Использовать резервный код',
      useAuthenticator: 'Ввести код из приложения',
      recoveryTitle: 'Резервный код',
      recoverySubtitle:
        'Введите один из резервных кодов, сохранённых при подключении двухфакторной защиты. Каждый код можно использовать один раз.',
      recoveryLabel: 'Резервный код',
      recoveryPlaceholder: 'xxxx-xxxx',
      recoveryRequired: 'Введите резервный код',
      errorInvalid: 'Неверный код. Проверьте приложение-аутентификатор и попробуйте ещё раз.',
      errorReplayed:
        'Этот код уже использован. Дождитесь появления нового кода в приложении и введите его.',
      errorLocked: 'Слишком много попыток. Подождите 15 минут и попробуйте снова.',
      errorNotConfigured: 'Для этого аккаунта двухфакторная защита не настроена.'
    }
  },
  security2fa: {
    title: 'Двухфакторная защита',
    subtitle: 'Одноразовый код из приложения-аутентификатора в дополнение к паролю.',
    statusEnabled: 'Подключена',
    statusDisabled: 'Не подключена',
    statusEnabledBody: 'При входе и денежных операциях запрашивается код из приложения.',
    statusDisabledBody: 'Аккаунт защищён только паролем. Рекомендуем подключить второй фактор.',
    enable: 'Подключить',
    startOver: 'Начать заново',
    setup: {
      title: 'Подключение',
      step1Title: 'Шаг 1. Отсканируйте QR-код',
      step1Body:
        'Откройте приложение-аутентификатор (Google Authenticator, 1Password, Aegis) и добавьте аккаунт.',
      qrLabel: 'QR-код для приложения-аутентификатора',
      cantScan: 'Не получается отсканировать?',
      manualKeyLabel: 'Ключ для ручного ввода',
      copyKey: 'Скопировать ключ',
      step2Title: 'Шаг 2. Подтвердите код',
      step2Body: 'Введите шестизначный код, который показывает приложение.',
      submit: 'Подключить',
      loadFailed: 'Не удалось получить данные для подключения.'
    },
    recovery: {
      title: 'Резервные коды',
      body: 'Десять одноразовых кодов на случай потери доступа к приложению-аутентификатору.',
      warningTitle: 'Эти коды показываются только один раз',
      warningBody:
        'Закрыв экран, вы больше не сможете их увидеть. Сохраните коды в менеджере паролей или распечатайте.',
      list: 'Список резервных кодов',
      copyAll: 'Скопировать все',
      download: 'Скачать файлом',
      filename: 'novix-recovery-codes.txt',
      fileHeader:
        'Резервные коды Novix. Каждый код можно использовать один раз. Храните их в безопасном месте.',
      savedCheckbox: 'Я сохранил(а) резервные коды в надёжном месте',
      done: 'Готово',
      enabledToast: 'Двухфакторная защита подключена.'
    },
    disable: {
      title: 'Отключить двухфакторную защиту',
      body: 'Введите текущий код из приложения-аутентификатора, чтобы подтвердить отключение.',
      warning:
        'После отключения аккаунт будет защищён только паролем, а сохранённые резервные коды перестанут действовать.',
      submit: 'Отключить',
      open: 'Отключить защиту',
      doneToast: 'Двухфакторная защита отключена.'
    }
  },
  stepUp: {
    title: 'Подтвердите операцию',
    description: 'Введите текущий код из приложения-аутентификатора.',
    submit: 'Подтвердить',
    reason: {
      money: 'Операция с деньгами требует подтверждения кодом.',
      'card-sensitive': 'Просмотр данных карты требует подтверждения кодом.',
      security: 'Изменение настроек безопасности требует подтверждения кодом.'
    }
  },
  otp: {
    label: 'Код подтверждения',
    digit: 'Цифра {{index}} из {{total}}',
    resendIn: 'Повторная отправка через {{seconds}} с',
    resendPrompt: 'Не пришёл код?',
    resend: 'Отправить снова',
    resending: 'Отправляем…'
  },
  // Книга контактов для переводов. Контакт — это личное название для ID:
  // сервер намеренно не сообщает, существует ли такой пользователь, поэтому
  // тексты ниже нигде не обещают проверку, которой не было.
  contacts: {
    title: 'Контакты',
    subtitle: 'Ваши личные названия для ID получателей.',
    add: 'Добавить контакт',
    idLine: 'ID {{id}}',
    editAction: 'Переименовать контакт «{{label}}»',
    deleteAction: 'Удалить контакт «{{label}}»',
    emptyTitle: 'Контактов пока нет',
    emptyBody:
      'Контакт — это ваше название для ID пользователя Novix. Сохраните ID один раз, и при переводе не придётся вводить его заново.',
    emptyPrivacy:
      'Контакты видите только вы. Novix не проверяет ID и никому не сообщает, что вы кого-то сохранили.',
    loadFailedTitle: 'Не удалось загрузить контакты',
    goToTransfer: 'Перейти к переводу',
    added: 'Контакт «{{label}}» добавлен',
    renamed: 'Контакт переименован в «{{label}}»',
    deleted: 'Контакт «{{label}}» удалён',
    deleteTitle: 'Удалить контакт?',
    deleteBody: 'Контакт «{{label}}» будет удалён из вашей книги. Отменить это нельзя.',
    deleteKeeps:
      'Прошлые переводы останутся в истории — удаляется только запись из вашей книги контактов.',
    pickerTitle: 'Выберите контакт',
    pickerHint: 'Перевод уйдёт на ID, сохранённый в этом контакте.',
    manage: 'Управлять контактами',
    chooseFromBook: 'Выбрать из контактов',
    clearChoice: 'Убрать',
    form: {
      addTitle: 'Новый контакт',
      addHint:
        'Novix не проверяет, существует ли такой пользователь, и не сообщает ему о сохранении. Проверьте ID сами.',
      renameTitle: 'Переименовать контакт',
      renameHint: 'Меняется только название. ID получателя остаётся прежним.',
      idLabel: 'ID пользователя Novix',
      idHint: 'Числовой ID, который получатель видит в своём профиле.',
      idInvalid: 'ID — это число.',
      idFixed: 'ID {{id}} — изменить нельзя',
      labelLabel: 'Как назвать контакт',
      labelHint: 'Видите только вы. До {{max}} символов.',
      labelTooLong: 'Название длиннее {{max}} символов.',
      addSubmit: 'Добавить'
    }
  },

  // Книга сохранённых карт для рублёвых выводов. Полный номер карты не
  // возвращается ни одним эндпоинтом — везде показывается только маска.
  cards: {
    title: 'Сохранённые карты',
    subtitle: 'Карты для вывода рублей — без повторного ввода номера.',
    add: 'Добавить карту',
    emptyTitle: 'Сохранённых карт пока нет',
    emptyBody:
      'Сохраните карту один раз, и при выводе рублей её можно будет выбрать из списка вместо ввода номера.',
    emptyPrivacy:
      'Номер карты хранится в зашифрованном виде и никогда не показывается целиком — ни здесь, ни в истории.',
    loadFailedTitle: 'Не удалось загрузить карты',
    goToPayout: 'Перейти к выводу на карту',
    added: 'Карта {{mask}} сохранена',
    edited: 'Карта {{mask}} изменена',
    deleted: 'Карта {{mask}} удалена',
    deleteTitle: 'Удалить карту?',
    deleteBody: 'Карта {{mask}} будет удалена из ваших сохранённых карт. Отменить это нельзя.',
    deleteKeeps:
      'Прошлые выводы останутся в истории — удаляется только сохранённая карта, не операции по ней.',
    pickerTitle: 'Выберите карту',
    pickerHint: 'Деньги уйдут на выбранную карту.',
    manage: 'Управлять картами',
    editAction: 'Изменить карту {{mask}}',
    deleteAction: 'Удалить карту {{mask}}',
    chooseFromBook: 'Выбрать сохранённую карту',
    clearChoice: 'Убрать',
    unreadableInstruction:
      'Эту карту больше не удаётся прочитать. Удалите её и сохраните заново — вывести на неё сейчас нельзя.',
    form: {
      addTitle: 'Новая карта',
      addHint: 'Номер карты отправляется один раз и обратно не возвращается.',
      editTitle: 'Изменить карту',
      editHint: 'Номер карты изменить нельзя. Чтобы указать другой, сохраните новую карту.',
      numberLabel: 'Номер карты',
      labelLabel: 'Название карты',
      labelPlaceholder: 'Например, «Зарплатная»',
      labelHint: 'Видите только вы. До {{max}} символов.',
      labelRequired: 'Придумайте название — по нему вы узнаете карту в списке.',
      labelTooLong: 'Название длиннее {{max}} символов.',
      addSubmit: 'Сохранить карту',
      privacyNote:
        'Мы сохраним номер в зашифрованном виде и покажем только первые шесть и последние четыре цифры.',
      rateLimited: 'Слишком часто. Подождите немного и попробуйте сохранить карту ещё раз.'
    }
  },

  profile: {
    title: 'Профиль',
    idLabel: 'ID {{id}}',
    copyId: 'Скопировать ID',
    copyIdValue: 'Скопировать ID {{id}}',
    idUnavailable: 'ID пока недоступен',
    contactSupport: 'Написать\nв поддержку',
    contactSupportPlain: 'Написать в поддержку',
    supportUnavailable: 'Канал поддержки ещё не подключён.',
    sectionProfile: 'Профиль',
    sectionSettings: 'Настройки',
    accountSafety: 'Безопасность аккаунта',
    contacts: 'Контакты',
    contactsHint: 'Ваши названия для ID получателей',
    savedCards: 'Сохранённые карты',
    savedCardsHint: 'Карты для вывода рублей',
    emailRow: 'Почта',
    emailUnknown: 'Не указана',
    passwordRow: 'Пароль',
    twoFactorRow: 'Двухфакторная защита',
    signOut: 'Выйти',
    signOutConfirmTitle: 'Выйти',
    signOutConfirmBody:
      'Вы уверены, что хотите выйти? При следующем входе потребуется снова ввести данные.',
    stayLoggedIn: 'Остаться в аккаунте',
    signedOut: 'Вы вышли из аккаунта.'
  },
  theme: {
    label: 'Тема',
    light: 'Светлая',
    dark: 'Тёмная',
    system: 'Как в системе',
    toggle: 'Переключить тему'
  },
  errors: {
    title: 'Что-то пошло не так',
    description: 'Не удалось отобразить этот раздел. Попробуйте обновить страницу.',
    notFound: 'Страница не найдена',
    notFoundDescription: 'Такой страницы нет или она была перемещена.',
    goHome: 'На главную',
    unknown: 'Непредвиденная ошибка. Попробуйте ещё раз.',
    kind: {
      http: 'Сервис временно недоступен. Попробуйте позже.',
      network: 'Нет связи с сервером. Проверьте подключение.',
      timeout: 'Сервер не ответил вовремя. Попробуйте ещё раз.',
      'rate-limit': 'Слишком много запросов. Подождите {{seconds}} с.',
      unauthorized: 'Сессия истекла. Войдите заново.',
      parse: 'Сервер вернул неожиданный ответ.'
    },
    code: {
      // Ключи — это errorCode из конверта бэкенда, один в один. Разбор текста
      // сообщения запрещён: он нестабилен и не переводится.
      invalid_credentials: 'Неверная почта или пароль.',
      account_locked: 'Слишком много попыток. Подождите 15 минут и попробуйте снова.',
      account_blocked: 'Аккаунт заблокирован. Обратитесь в поддержку.',
      invalid_token: 'Ссылка недействительна или срок её действия истёк.',
      invalid_refresh_token: 'Сессия истекла. Войдите заново.',
      refresh_token_reuse: 'Сессия прервана в целях безопасности. Войдите заново.',
      invalid_2fa_code: 'Неверный код подтверждения.',
      '2fa_code_already_used': 'Этот код уже использован. Дождитесь следующего.',
      '2fa_not_configured': 'Двухфакторная защита не настроена для этого аккаунта.',
      '2fa_already_enabled': 'Двухфакторная защита уже подключена.',
      '2fa_unavailable': 'Двухфакторная защита временно недоступна. Обратитесь в поддержку.',
      step_up_required: 'Требуется подтверждение кодом из приложения.',
      unauthenticated: 'Требуется вход в аккаунт.',
      validation_failed: 'Проверьте правильность заполнения полей.',
      INSUFFICIENT_FUNDS: 'Недостаточно средств.',

      // Вывод в криптовалюте
      crypto_unsupported_network: 'Эта сеть не поддерживается.',
      crypto_invalid_address: 'Адрес не подходит для выбранной сети. Проверьте адрес.',
      crypto_address_not_activated:
        'Этот адрес TRON ещё не активирован и не может принять USDT. Сначала отправьте на него немного TRX.',
      crypto_withdrawal_below_minimum: 'Сумма меньше минимальной для этой сети.',
      crypto_withdrawal_insufficient_funds:
        'На балансе недостаточно средств для этой суммы вместе с комиссией сети.',
      crypto_withdrawal_daily_limit_exceeded: 'Превышен дневной лимит на вывод. Попробуйте завтра.',
      crypto_withdrawal_temporarily_unavailable:
        'Выводы временно недоступны. Попробуйте немного позже.',
      crypto_provider_unavailable: 'Сервис временно недоступен. Попробуйте немного позже.',
      crypto_idempotency_key_reused: 'Эта операция уже была отправлена.',

      // Вывод рублей на карту
      payout_below_minimum: 'Сумма меньше минимальной для вывода на карту.',
      payout_invalid_card_number: 'Проверьте номер карты.',
      payout_insufficient_funds: 'На балансе недостаточно средств для этого вывода.',
      payout_provider_limit: 'Эта сумма сейчас недоступна. Попробуйте другую сумму.',
      payout_quote_unavailable: 'Выводы временно недоступны. Попробуйте немного позже.',
      payout_idempotency_key_reused: 'Эта операция уже была отправлена.',

      // Переводы
      transfer_below_minimum: 'Сумма меньше минимальной для перевода.',
      transfer_self: 'Нельзя перевести самому себе.',
      transfer_recipient_unavailable: 'Этот получатель не может принять перевод.',
      transfer_insufficient_funds: 'На балансе недостаточно средств для этого перевода.',
      transfer_idempotency_key_reused: 'Этот перевод уже был отправлен.',

      // Книга контактов. Все три безопасно показывать дословно: это ответы про
      // собственную книгу вызывающего, а не про чужие аккаунты.
      transfer_contact_not_found: 'Такого контакта нет в вашей книге.',
      transfer_contact_label_invalid: 'Укажите название контакта — не длиннее 64 символов.',
      transfer_contact_self: 'Нельзя добавить в контакты самого себя.',
      transfer_contact_already_exists: 'Этот пользователь уже есть в ваших контактах.',
      // Ошибка клиента, а не пользователя: отправлены оба способа адресации.
      transfer_recipient_ambiguous: 'Укажите либо ID получателя, либо контакт — но не оба сразу.',
      transfer_recipient_required: 'Укажите получателя.',

      // Сохранённые карты
      payout_saved_card_not_found: 'Такой сохранённой карты нет.',
      payout_saved_card_already_exists: 'Эта карта уже сохранена — она есть в вашем списке.',
      payout_saved_card_unreadable:
        'Эту карту больше не удаётся прочитать. Удалите её и сохраните заново.',
      payout_invalid_card_label: 'Нужно название карты — не длиннее 64 символов.',
      payout_card_ambiguous: 'Укажите либо номер карты, либо сохранённую карту — но не оба сразу.',
      payout_card_required: 'Выберите карту для вывода.'
    }
  }
} as const;
